// Creating constants for Ovulation-Calculator Module
const OC_Constants = Object.freeze({
    FIRST_DAY : 'FIRST_DAY',
    FERTILITY_INCREASING_DAY : 'FERTILITY_INCREASING_DAY',
    FIRST_FERTILE_DAY : 'FIRST_FERTILE_DAY',
    SECOND_FERTILE_DAY : 'SECOND_FERTILE_DAY',
    MOST_FERTILE_DAY : 'MOST_FERTILE_DAY',
    THIRD_FERTILE_DAY : 'THIRD_FERTILE_DAY',
    FERTILITY_DECREASING_DAY : 'FERTILITY_DECREASING_DAY',
    IMPLANTATION_DAY : 'IMPLANTATION_DAY',
    PREGNANCY_TEST_DAY : 'PREGNANCY_TEST_DAY',
    DEFAULT_CYCLE_LENGTH : 28,
    DEFAULT_PERIOD_DURATION : 4,
    MIN_PERIOD : 2,
    MAX_PERIOD : 12
});

export default OC_Constants;